import { languages } from "@mw/shared/languagesAndAccents";

export const AUDIO_DRIFT_CHECK_INTERVAL_MS = 800;
export const AUDIO_DRIFT_HARD_SYNC_THRESHOLD_SECONDS = 1.5;
export const AUDIO_DRIFT_MAX_PLAYBACK_RATE_DELTA = 0.06;
export const AUDIO_DRIFT_PLAYBACK_RATE_CORRECTION_FACTOR = 0.12;
export const AUDIO_DRIFT_TOLERANCE_SECONDS = 0.2;
export const AUDIO_METADATA_READY_STATE = 1;
export const EAGER_LANGUAGE_TRACK_PRELOAD_COUNT = 5;
export const VIDEO_IDLE_BLUR = 0;
export const VIDEO_IDLE_OPACITY = 1;
export const VIDEO_IDLE_SCALE = 1.01;
export const VIDEO_PRESS_BLUR = 2;
export const VIDEO_PRESS_OPACITY = 0.85;
export const VIDEO_PRESS_SCALE = 1.03;
export const VIDEO_REBOUND_DELAY_MS = 110;
export const VIDEO_PULSE_SPRING = { damping: 16, mass: 2, stiffness: 210 };
export const VIDEO_PULSE_BLUR_MEDIA_QUERY = "(min-width: 48rem)";
export const VIDEO_BOTTOM_GRADIENT =
  "linear-gradient(to top, rgb(0 0 0 / 0.46) 0%, rgb(0 0 0 / 0.42) 12%, rgb(0 0 0 / 0.35) 25%, rgb(0 0 0 / 0.27) 38%, rgb(0 0 0 / 0.18) 52%, rgb(0 0 0 / 0.11) 66%, rgb(0 0 0 / 0.06) 78%, rgb(0 0 0 / 0.025) 89%, rgb(0 0 0 / 0.006) 96%, rgb(0 0 0 / 0) 100%)";
export const VIDEO_BOTTOM_GRADIENT_MASK =
  "linear-gradient(to top, black 0%, rgb(0 0 0 / 0.98) 22%, rgb(0 0 0 / 0.84) 42%, rgb(0 0 0 / 0.58) 62%, rgb(0 0 0 / 0.28) 80%, rgb(0 0 0 / 0.08) 93%, rgb(0 0 0 / 0) 100%)";
export const VIDEO_BOTTOM_GRADIENT_STYLE = {
  backgroundImage: VIDEO_BOTTOM_GRADIENT,
} as const;
export const VIDEO_BOTTOM_BLUR_STYLE = {
  WebkitMaskImage: VIDEO_BOTTOM_GRADIENT_MASK,
  maskImage: VIDEO_BOTTOM_GRADIENT_MASK,
} as const;
export const TRACK_CHEVRON_MOTION_CLASS =
  "tw-duration-[650ms] tw-ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:tw-duration-0";
export const LANGUAGE_SCROLL_FADE_SIZE_REM = 2;
export const LANGUAGE_SCROLL_FADE_SIZE = `${LANGUAGE_SCROLL_FADE_SIZE_REM}rem`;
export const LANGUAGE_SCROLL_EDGE_TRIGGER_SIZE_REM = 4;
export const LANGUAGE_SCROLL_EDGE_PEEK_BIAS_REM = 3;
export const LANGUAGE_SCROLL_ADJUSTMENT_MEDIA_QUERY = "(min-width: 48rem)";
export const LANGUAGE_SCROLL_MASK_IMAGE = `linear-gradient(to right, transparent 0, rgba(0,0,0,0.02) 0.2rem, rgba(0,0,0,0.08) 0.4rem, rgba(0,0,0,0.2) 0.65rem, rgba(0,0,0,0.42) 0.95rem, rgba(0,0,0,0.68) 1.25rem, rgba(0,0,0,0.88) 1.55rem, rgba(0,0,0,0.98) 1.8rem, black ${LANGUAGE_SCROLL_FADE_SIZE}, black calc(100% - ${LANGUAGE_SCROLL_FADE_SIZE}), rgba(0,0,0,0.98) calc(100% - 1.8rem), rgba(0,0,0,0.88) calc(100% - 1.55rem), rgba(0,0,0,0.68) calc(100% - 1.25rem), rgba(0,0,0,0.42) calc(100% - 0.95rem), rgba(0,0,0,0.2) calc(100% - 0.65rem), rgba(0,0,0,0.08) calc(100% - 0.4rem), rgba(0,0,0,0.02) calc(100% - 0.2rem), transparent 100%)`;
export const LANGUAGE_SCROLL_MASK_STYLE = {
  WebkitMaskImage: LANGUAGE_SCROLL_MASK_IMAGE,
  maskImage: LANGUAGE_SCROLL_MASK_IMAGE,
} as const;
export const languageLabelByLocale = new Map(languages.map(language => [language.value, language.label]));

export function getDubbingLanguageLabel(locale: string) {
  return languageLabelByLocale.get(locale) ?? locale.toUpperCase();
}
